module.exports = __webpack_public_path__ + "img/promote-account.4d79c373.png";